import { useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import Modal from "./Modal";

const TITLES = { set: "Set a carer PIN", change: "Change carer PIN", remove: "Remove carer PIN" };

export default function PinModal({ mode, onClose }) {
  const { refreshUser } = useAuth();
  const [currentPin, setCurrentPin] = useState("");
  const [pin, setPin] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const inputCls = "w-full min-h-[56px] rounded-2xl border-2 border-foreground/25 bg-white px-4 text-lg tracking-widest focus:outline-none focus:border-primary";

  const submit = async () => {
    setError("");
    if (mode !== "remove") {
      if (!/^\d{4,8}$/.test(pin)) return setError("PIN must be 4 to 8 digits");
      if (pin !== confirm) return setError("PINs don't match");
    }
    setBusy(true);
    try {
      if (mode === "remove") {
        await api.delete("/auth/pin", { data: { pin: currentPin } });
        toast.success("Carer PIN removed");
      } else {
        await api.post("/auth/pin", { pin, current_pin: currentPin || undefined });
        toast.success(mode === "set" ? "Carer PIN set — Carer Mode is now protected" : "PIN changed");
      }
      await refreshUser();
      onClose();
    } catch (e) {
      setError(apiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal title={TITLES[mode]} onClose={onClose} testId="pin-modal">
      <div className="space-y-4">
        {(mode === "change" || mode === "remove") && (
          <div>
            <label htmlFor="current-pin" className="block text-base font-bold mb-1">Current PIN</label>
            <input id="current-pin" data-testid="current-pin-input" type="password" inputMode="numeric" value={currentPin} onChange={(e) => setCurrentPin(e.target.value.replace(/\D/g, ""))} className={inputCls} maxLength={8} />
          </div>
        )}
        {mode !== "remove" && (
          <>
            <div>
              <label htmlFor="new-pin" className="block text-base font-bold mb-1">New PIN (4–8 digits)</label>
              <input id="new-pin" data-testid="new-pin-input" type="password" inputMode="numeric" value={pin} onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))} className={inputCls} maxLength={8} />
            </div>
            <div>
              <label htmlFor="confirm-pin" className="block text-base font-bold mb-1">Confirm new PIN</label>
              <input id="confirm-pin" data-testid="confirm-pin-input" type="password" inputMode="numeric" value={confirm} onChange={(e) => setConfirm(e.target.value.replace(/\D/g, ""))} className={inputCls} maxLength={8} />
            </div>
          </>
        )}
        {error && <p data-testid="pin-modal-error" className="text-[#C53030] font-semibold bg-[#F56565]/10 border-2 border-[#F56565]/40 rounded-2xl px-4 py-3">{error}</p>}
        <button
          data-testid="pin-modal-submit"
          onClick={submit}
          disabled={busy}
          className={`w-full min-h-[56px] rounded-full text-white text-lg font-bold disabled:opacity-60 ${mode === "remove" ? "bg-[#C53030]" : "bg-primary"}`}
        >
          {busy ? "Please wait…" : TITLES[mode]}
        </button>
      </div>
    </Modal>
  );
}
